export default __webpack_public_path__ + "static/media/access_denied.de4f8c3f.png";